import BrandLoader from './BrandLoader';

export default BrandLoader;
